import type { Device } from "luxedo-data"

class CalMinControl {
	instances: { [index: Device["id"]]: boolean } = $state({})

	open = (device: Device) => {
		this.instances[device.id] = true
	}

	hide = (device: Device) => {
		delete this.instances[device.id]
	}

	private reset = () => {
		this.instances = {}
	}
}

export const CalibrationMinimizedController = new CalMinControl()
